export var _sectionLabelTheme = {
  baseStyle: {
    display: 'flex',
    gap: 'xs',
    textStyle: 'body4Semi',
    textTransform: 'uppercase',
    color: 'neutral.darker'
  }
};
//# sourceMappingURL=_SectionLabel.theme.js.map